export const DEFAULT_ERROR = "errors.legacy.login.defaultError"
export const ALREADY_EXISTS = "errors.legacy.ssu.alreadyExists"
export const INVALID_EMAIL_DOMAIN = "errors.legacy.ssu.emailDomainIncorrect"
export const INVALID_CODE = "errors.legacy.ssu.codeIncorrect"
export const NOT_AVAILABLE = "errors.legacy.ssu.notAvailable"
export const VALIDATION_FAILED = "Validation failed"
export const RESOURCE_UPDATED = "The resource has updated. Please reload and try again."

export const selfSignUpSettingsPutErrorHandler = (code) => {
  switch (code) {
    default:
      return ""
  }
}
